// Utility functions that are specific to the inner workings of the `NavTree` component.
import { NavigatorItemType } from 'cadenza/navigator/navigator-icon-type';
import type { NavigatorTreeNodeDto, NavigatorTreeNodeId } from 'cadenza/repository/model/navigator-tree-node-dto';

export class ActionNodeClickEvent extends CustomEvent<{ nodeId: string }> {
  static readonly type = 'action-node-click';
  /** @param nodeId - DOM ID of the clicked node */
  constructor(nodeId: string) {
    super(ActionNodeClickEvent.type, { bubbles: true, detail: { nodeId } });
  }
}

export function navTreeNodeHtmlId(nodeId: NavigatorTreeNodeId) {
  return `d-nav-tree-node_${nodeId.replace(/[.:()\s/]/g, '-')}`;
}

export function getNavigatorItemType(node: NavigatorTreeNodeDto): NavigatorItemType | undefined {
  const itemType = node.itemType;
  if (itemType === 'WORKSHEET') {
    return node.worksheetIcon === 'MIXED' ? 'WORKSHEET' : node.worksheetIcon;
  }
  if (NavigatorItemType.includes(itemType)) {
    return itemType;
  }
}

// 'WORKSHEET' is filtered as 'WORKBOOK'
export type NavigatorFilterItemType = Exclude<NavigatorItemType, 'WORKSHEET'>;

export function getNavigatorFilterItemType(node: NavigatorTreeNodeDto): NavigatorFilterItemType | undefined {
  const navigatorItemType = getNavigatorItemType(node);
  return navigatorItemType === 'WORKSHEET' ? 'WORKBOOK' : navigatorItemType;
}
